var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.9985 24.0001H50.9985V18.0001C50.9985 9.72006 44.2785 3.00006 35.9985 3.00006C27.7185 3.00006 20.9985 9.72006 20.9985 18.0001V24.0001H17.9985C14.6985 24.0001 11.9985 26.7001 11.9985 30.0001V60.0001C11.9985 63.3001 14.6985 66.0001 17.9985 66.0001H53.9985C57.2985 66.0001 59.9985 63.3001 59.9985 60.0001V30.0001C59.9985 26.7001 57.2985 24.0001 53.9985 24.0001ZM35.9985 51.0001C32.6985 51.0001 29.9985 48.3001 29.9985 45.0001C29.9985 41.7001 32.6985 39.0001 35.9985 39.0001C39.2985 39.0001 41.9985 41.7001 41.9985 45.0001C41.9985 48.3001 39.2985 51.0001 35.9985 51.0001ZM26.9993 24V18C26.9993 13.02 31.0193 9.00004 35.9993 9.00004C40.9793 9.00004 44.9993 13.02 44.9993 18V24H26.9993Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.93291cb0533f73615020b7823e7657ab.svg";
export { ForwardRef as ReactComponent };